<script>
    import * as ze from "@axel669/zephyr"

    import { numericInput } from "./numeric.js"

    let {
        bag = $bindable()
    } = $props()

    const weight = numericInput(bag, "weight")
</script>

<ze.Input type="text" label="Bag Name" linedFill bind:value={bag.name} />
<ze.Input type="number" label="Bag Weight" linedFill bind:value={weight.get, weight.set} />
<ze.Toggle checkbox label="Include Item Weight" bind:checked={bag.include.weight} />
<ze.Toggle checkbox label="Include Coins in Total" bind:checked={bag.include.coins} />
<ze.Input type="area" label="Bag Description" linedFill bind:value={bag.info} h="7em" />
